export default class extends Controller {
  static targets = ['startDateField', 'dateDisplay'];

  connect() {
    this.updateRepeatOptions();
  }

  updateRepeatOptions() {
    this.dateDisplayTarget.innerText = this.dateDisplay;
  }

  //
  // GETTERS AND SETTERS
  //

  get dateDisplay() {
    return moment(this.startDateFieldTarget.value).format('MMMM Do');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/events/campaign-brief-event-repeat-year-fields-controller.js